export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';

export const UPDATE_VOICE_PROFILE_REQUEST = 'UPDATE_VOICE_PROFILE_REQUEST';
export const UPDATE_VOICE_PROFILE_SUCCESS = 'UPDATE_VOICE_PROFILE_SUCCESS';
export const UPDATE_VOICE_PROFILE_FAILURE = 'UPDATE_VOICE_PROFILE_FAILURE';

export const FETCH_VOICE_PROFILE_REQUEST = 'FETCH_VOICE_PROFILE_REQUEST';
export const FETCH_VOICE_PROFILE_SUCCESS = 'FETCH_VOICE_PROFILE_SUCCESS';
export const FETCH_VOICE_PROFILE_FAILURE = 'FETCH_VOICE_PROFILE_FAILURE';

export const updatePassword = (currentPassword, newPassword) => ({
  type: UPDATE_PASSWORD_REQUEST,
  payload: { currentPassword, newPassword },
});

export const updateVoiceProfile = (lang, vocabulary) => ({
  type: UPDATE_VOICE_PROFILE_REQUEST,
  payload: { lang, vocabulary },
});

export const fetchVoiceProfile = () => ({
  type: FETCH_VOICE_PROFILE_REQUEST,
});
